<template>
  <div>
    <p class="mt-2 mb-0">
      La espera corre desde lo más tarde entre la llegada del repartidor y la
      salida programada, hasta que inicia la ruta. Se descuentan
      {{ details.toleranceMinutes }} min de tolerancia.
    </p>
    <ContentMetrics>
      <template>
        <Metric :value="details.totalRoutes" :title="'Total de Rutas'" :border="true" />
        <Metric :value="details.totalRoutesWithMarks" :title="'Con marcas'" :border="true" />
        <Metric :value="details.totalRoutesWithExcess" :title="'Con exceso'" :border="true" />
        <Metric :value="averageLabel" :title="'Exceso promedio (min)'" :border="true" />
        <Metric :value="details.score" :title="'Score'" />
      </template>
    </ContentMetrics>
    <div class="mt-4 mb-4 content-table-level">
      <el-table
        v-if="details.routes.length !== 0"
        :data="details.routes"
        row-key="id"
        header-row-class-name="thead-desing-dark"
        class="desing-dark"
      >
        <el-table-column label="Fecha" prop="date" min-width="90px" />
        <el-table-column label="Ruta Asignada" prop="route" min-width="116px">
          <template v-slot="{ row }"><strong>{{ row.route }}</strong></template>
        </el-table-column>
        <el-table-column label="Salida programada" prop="scheduled_departure_time" min-width="110px" />
        <el-table-column label="Llegada" prop="arrival_time" min-width="95px" />
        <el-table-column label="Inicio de ruta" prop="route_started_time" min-width="100px" />
        <el-table-column label="Espera (min)" prop="wait_minutes" min-width="95px">
          <template v-slot="{ row }">{{ describeWait(row) }}</template>
        </el-table-column>
        <el-table-column label="Exceso (min)" prop="excess_minutes" min-width="105px">
          <template v-slot="{ row }">
            <strong
              class="tag-level-desing"
              :class="{ red: row.excess_minutes > 0, green: row.excess_minutes === 0 }"
              >{{ row.has_marks ? row.excess_minutes : NO_WAIT_MARKS_LABEL }}</strong
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import ContentMetrics from "@/components/Levels/ContentMetrics";
import Metric from "@/components/Levels/Metric";
import { NO_WAIT_MARKS_LABEL } from "@/utils/dealerWaitThresholds";

const ROUTE_LEFT_EARLY_LABEL = "Salió antes";
const NO_WAIT_MINUTES = 0;

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ContentMetrics,
    Metric
  },
  props: {
    details: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    NO_WAIT_MARKS_LABEL
  }),
  computed: {
    averageLabel() {
      return this.details.averageWaitExcessMinutes === null
        ? NO_WAIT_MARKS_LABEL
        : this.details.averageWaitExcessMinutes;
    }
  },
  methods: {
    describeWait(row) {
      if (!row.has_marks) {
        return NO_WAIT_MARKS_LABEL;
      }

      return row.wait_minutes < NO_WAIT_MINUTES ? ROUTE_LEFT_EARLY_LABEL : row.wait_minutes;
    }
  }
};
</script>
